import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";


function Broken(){
    return (
        <div className="Broken">

            <h1>
                So....We have to restrict this for now, sorry about that.
            </h1>
            <h1>
                Please feel free to check out any of my other projects!!
            </h1>

        </div>
    ); 
}
export default Broken;